<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g :stroke="color" stroke-width="2">
                <path
                  d="M19 10c0 2.485-1.007 4.735-2.636 6.364C14.735 17.993 12.485 19 10 19c-2.486 0-4.736-1.007-6.364-2.636C2.007 14.736 1 12.486 1 10c0-2.486 1.007-4.736 2.636-6.364C5.264 2.007 7.514 1 10 1c2.485 0 4.735 1.007 6.364 2.636C17.993 5.265 19 7.515 19 10z"
                  transform="translate(-48 -398) translate(34 374) translate(14 24)"
                />
              </g>
              <path
                :fill="color"
                fill-rule="nonzero"
                d="M6.293 6.293c.36-.36.928-.388 1.32-.083l.094.083 6 6c.39.39.39 1.024 0 1.414-.36.36-.928.388-1.32.083l-.094-.083-6-6c-.39-.39-.39-1.024 0-1.414z"
                transform="translate(-48 -398) translate(34 374) translate(14 24)"
              />
              <path
                :fill="color"
                fill-rule="nonzero"
                d="M12.293 6.293c.39-.39 1.024-.39 1.414 0 .36.36.388.928.083 1.32l-.083.094-6 6c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094 6-6z"
                transform="translate(-48 -398) translate(34 374) translate(14 24)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
